export const DEFAULT_ICON_SIZE = 24
export const TRANSITION_TIME_MS = 400
export const DEFAULT_MODAL_WIDTH = 564
export const DEFAULT_DRAWER_WIDTH = 375
